import React from 'react'
import { connect } from 'react-redux'
import { favorites } from 'redux/modules'
import FavoriteIcon from '@material-ui/icons/Favorite'
import { IconButton } from '@material-ui/core'
import PropTypes from 'prop-types'

const ENTITY_TO_MODULE_MAPPER = {
  videos: isActive =>
    isActive
      ? favorites.deleteVideoFromFavorites
      : favorites.addVideoToFavorites,
  sequences: isActive =>
    isActive
      ? favorites.deleteSequenceFromFavorites
      : favorites.addSequenceToFavorites,
}

const HeartIcon = ({ isActive, action }) => (
  <IconButton onClick={e => {
    e.preventDefault()
    e.stopPropagation()

    action()
  }}>
    <FavoriteIcon
      className="heart-icon"

      color={isActive ? 'primary' : 'disabled'}
      fontSize="small"
    />
  </IconButton>
)

HeartIcon.defaultProps = {
  isActive: false,
}

HeartIcon.propTypes = {
  isActive: PropTypes.bool,
  action: PropTypes.func.isRequired,
}

export default connect(
  null,
  (dispatch, { isActive, entity, entityId }) => ({
    action: () => dispatch(ENTITY_TO_MODULE_MAPPER[entity](isActive)(entityId)),
  })
)(HeartIcon)
